{
    "Profile_UnderwriterCoverageAdjustment.header": "FR: Underwriter Coverage Adjustment",
    "Profile_UnderwriterCoverageAdjustment.premiums": "FR: Premiums",
    "Profile_UnderwriterCoverageAdjustment.fees": "FR: Fees",
    "Profile_UnderwriterCoverageAdjustment.discounts": "FR: Discounts",
    "Profile_UnderwriterCoverageAdjustment.surcharge": "FR: Surcharge",
    "Profile_UnderwriterCoverageAdjustment.modal.editTitle": "FR: Edit {label}",
    "Profile_UnderwriterCoverageAdjustment.modal.addTitle": "FR: Add {type} Adjustment",
    "Profile_UnderwriterCoverageAdjustment.modal.premiumType": "FR: Premium",
    "Profile_UnderwriterCoverageAdjustment.modal.feeType": "FR: Fee",
    "Profile_UnderwriterCoverageAdjustment.modal.discountType": "FR: Discount",
    "Profile_UnderwriterCoverageAdjustment.modal.surchargeType": "FR: Surcharge",
    "Profile_UnderwriterCoverageAdjustment.modal.currentAmount": "FR: Current amount",
    "Profile_UnderwriterCoverageAdjustment.modal.adjustmentMethod": "FR: Adjustment method",
    "Profile_UnderwriterCoverageAdjustment.modal.flatAmount": "FR: Flat amount",
    "Profile_UnderwriterCoverageAdjustment.modal.absoluteAmount": "FR: Absolute amount",
    "Profile_UnderwriterCoverageAdjustment.modal.percentage": "FR: Percentage",
    "Profile_UnderwriterCoverageAdjustment.modal.value": "FR: Value",
    "Profile_UnderwriterCoverageAdjustment.modal.description": "FR: Description",
    "Profile_UnderwriterCoverageAdjustment.modal.cancel": "FR: Cancel",
    "Profile_UnderwriterCoverageAdjustment.modal.apply": "FR: Apply",
    "Profile_UnderwriterCoverageAdjustment.modal.rangeHelper": "FR: Allowed range",
    "Profile_UnderwriterCoverageAdjustment.apply": "FR: Apply Changes",
    "Profile_UnderwriterCoverageAdjustment.applied": "FR: Applied"
}
